import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { GovoLoading } from "../../../assets/logos";
import { Check, Cancel, Warning } from "../../../assets/logos/icons";
import "./dialogSystemGL.css";

/* === Custom component title for dialog loading === */
const CustomLoadingTitleBar = (props) => {
  const { t } = useTranslation();
  return (
    <div className="dialogSystemGLPure-customTitleBarStyles">
      {/* <span>{t("dialogSystemGLPure.titleDialogSignRequest")}</span> */}
    </div>
  );
};

/* === Custom component title for dialog complete === */
const CustomCompleteTitleBar = (props) => {
  const { t } = useTranslation();
  return (
    <div className="dialogSystemGLPure-customTitleBarStyles">
      <span>{t("dialogSystemGLPure.titleDialogSignRequest")}</span>
    </div>
  );
};

/* === Custom component title for dialog error === */
const CustomErrorTitleBar = (props) => {
  const { t } = useTranslation();
  return (
    <div className="dialogSystemGLPure-customTitleBarStyles">
      <span>{t("dialogSystemGLPure.titleDialogSignRequest")}</span>
    </div>
  );
};


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const DialogSystemGLPure = (props) => {
  const {
    showLoadingRequesting, //State for loading dialog
    showCompletedRequesting, //State for complete dialog
    showErrorRequesting, //State for error dialog
    showWarningRequesting, //State for warning dialog
    isWarnign, //State for other warning dialog
    toggleLoadingRequesting, //Function to change state for loading dialog
    toggleCompletedRequesting, //Function to change state for complete dialog
    toggleErrorRequesting, //Function to change state for error dialog
    toggleWarningRequesting, //Function to change state for warning dialog
    message, //Text message to error, warning, completed
    messageError,//Text message to error,
    messageComplete,// //Text message to completed,
    messageWarning, //Text message to warning
    heightLoading, //Property ton send height if this change, the standard is auto 
    widthLoading, //Property ton send width if this change, the standard is 500px  
    handleWarning, //Show second warning
  } = props;
  const { t } = useTranslation();

  //Function, hooks, you can use this to extract the value of the input wherever you are going to use it
  //Example function to dialog loading
  // toggleLoadingRequesting = (value) => {
  //   this.setState({
  //     showLoadingRequesting: value,
  //   });
  // };

  //Example function to dialog completed request
  // toggleCompletedRequesting = (value) => {
  //   this.setState(
  //     {
  //       showCompletedRequesting: value,
  //     },
  //     () => {
  //       setTimeout(() => {
  //         this.setState({ showCompletedRequesting: false });
  //       }, 4000);
  //     }
  //   );
  // };

  //Example function to dialog error request-
  // toggleErrorRequesting = (value) => {
  //   this.setState(
  //     {
  //       showErrorRequesting: value,
  //     },
  //     () => {
  //       setTimeout(() => {
  //         this.setState({ showErrorRequesting: false });
  //       }, 6000);
  //     }
  //   );
  // };

  return (
    <div>
      {/* === DIALOG LOADIGN === */}
      {showLoadingRequesting && (
        <Dialog
          // width={widthLoading}
          // height={heightLoading}
          className={"dialogSystemGLPure-loading"}
          onClose={() => { toggleLoadingRequesting() }}
          title={<CustomLoadingTitleBar />}
        >
          {/**Loading icon**/}
          <div className="dialogSystemGLPure-containerIcon">
            <img
              alt=""
              src={GovoLoading}
              className="dialogSystemGLPure-imgNotification"
            ></img>
          </div>
          {/**Loading text**/}
          <div className="dialogSystemGLPure-textLoading">
            <p className="dialogSystemGLPure-text">
              {t("dialogSystemGLPure.titleExecutingRequest")}
            </p>
            <p className="dialogSystemGLPure-text">{t("dialogSystemGLPure.subtitleExecutingRequest")}</p>
          </div>
        </Dialog>
      )}

      {/* === DIALOG SUCCESSFUL === */}
      {showCompletedRequesting && (
        <Dialog
          title={<CustomCompleteTitleBar />}
          onClose={() => {
            toggleCompletedRequesting();
          }}
        >
          <div className="dialogSystemHLPure-containerIcon">
            <img alt="" src={Check} />
          </div>
          <p className="dialogSystemHLPure-text">
            {messageComplete ? messageComplete : t("dialogSystemGLPure.requestSucces")}
          </p>
        </Dialog>
      )}

      {/* === DIALOG ERROR === */}
      {showErrorRequesting && (
        <Dialog
          className="DialogSystemHL-hide-scroll"
          title={<CustomErrorTitleBar />}
          onClose={() => {
            toggleErrorRequesting();
          }}
          width={290}
        // height={340}
        >
          <div className="dialogSystemHLPure-containerIcon">
            <img alt="" src={Cancel} />
          </div>
          {message || messageError ? (
            <p className="dialogSystemHLPure-text">{message ? message : messageError}</p>
          ) : (
            <p className="dialogSystemHLPure-text">
              {t("dialogSystemGLPure.anErrorOcurredInTheRequesting")}
            </p>
          )}
        </Dialog>
      )}
      {/* === DIALOG WARNING === */}
      {showWarningRequesting && (
        <Dialog
          title={<CustomErrorTitleBar />}
          onClose={() => {
            toggleWarningRequesting();
          }}
          width={290}
        // height={340}
        >
          <div className="dialogSystemHLPure-containerIcon">
            <img alt="" src={Warning} />
          </div>
          {message || messageWarning ? (
            <p className="dialogSystemHLPure-text">{message ? message : messageWarning}</p>
          ) : (
            <p className="dialogSystemGLPure-text">
              {t("dialogSystemGLPure.anErrorOcurredInTheRequesting")}
            </p>
          )}
        </Dialog>
      )}

      {isWarnign && (
        <Dialog
          className="DialogSystemHL-hide-scroll"
          title={<CustomErrorTitleBar />}
          onClose={handleWarning}
          width={290}
        // height={340}
        >
          <div className="dialogSystemHLPure-containerIcon">
            <img alt="" src={Warning} />
          </div>
          {message || messageWarning ? (
            <p className="dialogSystemHLPure-text">{message ? message : messageWarning}</p>
          ) : (
            <p className="dialogSystemGLPure-text">
              {t("dialogSystemGLPure.anErrorOcurredInTheRequesting")}
            </p>
          )}
        </Dialog>
      )}
    </div>
  );
};

export default DialogSystemGLPure;
